import React from 'react';
import { Link } from 'react-router-dom';

function Redes() {
  return (
    <div className="container text-light mt-5 px-3">
      <div
        className="p-4 rounded-4 shadow-lg"
        style={{
          backgroundColor: 'rgba(255, 255, 255, 0.05)',
          backdropFilter: 'blur(8px)',
          border: '1px solid rgba(255, 255, 255, 0.1)'
        }}
      >
        <h2 className="mb-3 text-white text-center">
          <i className="bi bi-router me-2 text-info"></i>
          Redes e Monitoramento
        </h2>

        <p className="text-white-50 text-center mb-4">
          Atuamos com projetos robustos de redes locais (LAN), redes distribuídas (WAN) e infraestrutura lógica,
          combinando performance, segurança e disponibilidade. Nossa equipe entrega soluções escaláveis para todos os setores.
        </p>

        <ul className="text-light fs-6">
          <li className="mb-3">
            <i className="bi bi-diagram-3-fill me-2 text-primary"></i>
            <strong>Arquitetura de rede:</strong> Projetos de redes locais e interconectadas, com topologia inteligente e redundância.
          </li>
          <li className="mb-3">
            <i className="bi bi-cpu-fill me-2 text-success"></i>
            <strong>Cabeamento estruturado:</strong> Implantação com CAT5e, CAT6 e fibra óptica, com testes de certificação.
          </li>
          <li className="mb-3">
            <i className="bi bi-gear-wide-connected me-2 text-warning"></i>
            <strong>Gerenciamento lógico:</strong> VLANs, VPNs, failover, NAT, firewall e roteamento avançado.
          </li>
          <li className="mb-3">
            <i className="bi bi-speedometer2 me-2 text-danger"></i>
            <strong>Monitoramento de rede:</strong> Controle de ativos, banda, uptime e alertas inteligentes via NOC.
          </li>
        </ul>

        <div className="mt-4 text-center">
          <Link to="/contato" className="btn btn-outline-info btn-lg px-4">
            Consultoria de rede
          </Link>
        </div>
      </div>
    </div>
  );
}

export default Redes;
